<template>
  <div id="UserCenter">
    <!-- 用户中心 -->
    <div class="banner">
      <!-- <el-image class="background" :src="require('@/assets/imgs/banner2.jpeg')" fit='cover'></el-image> -->
      <el-image class="background" :src="banner" fit='cover'></el-image>
      <!-- <b class="mask"></b>
      <div class="main">
        <img class="ban" src="../../assets/imgs/banner.png" alt="">
        <div class="cont">
          <p>参与投稿</p>
          <b>项目周期：2024年3月-2025年4月</b>
          <b>指导发起单位：中国初级卫生保健基金会</b>
          <b>执行单位：北京生命绿洲公益服务中心</b>
          <b>鸣谢支持：<img :src="require('@/assets/imgs/QL_logo2.png')" alt=""></b>
        </div>
      </div> -->
      <!-- <img class="frame" src="../../assets/imgs/Frame.png" alt=""> -->
    </div>
    <div class="user" v-if="userInfo">
      <el-avatar :src="require('../../assets/imgs/userbase.png')" icon="el-icon-user-solid"></el-avatar>
      <el-divider direction="vertical"></el-divider>
      <div class="tougao">
        <p>{{ Statistics && Statistics.AllNum ? Statistics.AllNum : '0' }}</p>
        <b>投稿数</b>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="tongguo">
        <p>{{ Statistics && Statistics.SuccessNum ? Statistics.SuccessNum : '0' }}</p>
        <b>入围数</b>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="opts">
        <!--        <el-button @click="switchItems">切换项目</el-button>-->
        <el-button @click="logOut">退出登录</el-button>
      </div>
    </div>
    <div class="user" v-if="!userInfo">
      <el-avatar :src="require('../../assets/imgs/userbase2.png')" icon="el-icon-user-solid"></el-avatar>
      <el-divider direction="vertical"></el-divider>
      <div class="tougao">
        <p>-</p>
        <b>投稿数</b>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="tongguo">
        <p>-</p>
        <b>入围数</b>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="opts">
        <el-button @click="loginDialogFun('登录')">登录</el-button>
        <el-button @click="loginDialogFun('注册')">注册</el-button>
      </div>
    </div>
    <div class="part3">
      <div class="tit">
        <p>参与投稿</p>
        <b>participate in activities</b>
      </div>

      <div class="cont">
        <dl @click="registerDialogCk() ">
          <dt>
            <img src="../../assets/imgs/grzc.svg" alt="">
          </dt>
          <dd v-if="userInfo.fullName">修改资料</dd>
          <dd v-else>完善资料</dd>
        </dl>
        <dl @click="contributeDialogCk()">
          <dt>
            <img src="../../assets/imgs/wzsc.svg" alt="">
          </dt>
          <dd>立即投稿</dd>
        </dl>
        <dl v-if="showAIAssistantIcon" @click="goToAIAssistant()">
          <dt>
            <img src="../../assets/imgs/aigenerate.svg" alt="">
          </dt>
          <dd>AI助手</dd>
        </dl>
        <dl @click="download(`/article/template/downloadTemplate`)">
          <dt>
            <img src="../../assets/imgs/mbxz.svg" alt="">
          </dt>
          <dd>资料下载</dd>
        </dl>
        <!-- <dl @click="download(`/article/template/downloadInvitation`)"> -->
        <dl @click="download(`/article/template/downloadInvitation`)">
          <dt>
            <img src="../../assets/imgs/yqh.svg" alt="">
          </dt>
          <dd>邀请函下载</dd>
        </dl>
      </div>
    </div>
    <div class="part2">
      <div class="tit">
        <p>投稿记录</p>
        <b>Submission Record</b>
      </div>

      <div class="cont">
        <div class="document">
          <el-table :data="tableData" style="width: 100%">
            <!--            <el-table-column label="编号" width="80">-->
            <!--              <template slot-scope="scope">-->
            <!--                {{ scope.row.id }}-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column fixed min-width="200">
              <template slot="header" slot-scope="scope">
                文档名称
              </template>
              <template slot-scope="scope">
                {{ scope.row.documentName }}
              </template>
            </el-table-column>

            <!--            动态生成的表单字段列表-->
            <template v-for="(field,index) in formConfig">
              <el-table-column :prop="field.key" :label="field.label" :key="index">
                <template slot-scope="scope">

                  <!--                  &lt;!&ndash; 处理不同类型 &ndash;&gt;-->
                  <!--                  <template v-if="field.type === 'dict' && field.dictKey">-->
                  <!--                    {{ formatDictValue(scope.row[field.key], field) }}-->
                  <!--                  </template>-->

                  <!--                  <template v-else-if="field.type === 'datetime'">-->
                  <!--                    {{  scope.row[field.key]?  $moment(scope.row[field.key]).format('YYYY/MM/DD HH:mm') : '未审核' }}-->
                  <!--                  </template>-->

                  <!--                  <template v-else-if="field.type === 'status'">-->
                  <!--                    {{ formatStatus(scope.row[field.key]) }}-->
                  <!--                  </template>-->

                  <!-- 处理不同字段类型的显示 -->
                  <template v-if="field.type === 'checkbox'">
                    {{ formatCheckboxValue(scope.row[field.key], field) }}
                  </template>

                  <template v-else-if="field.type === 'radio'">
                    {{ formatRadioValue(scope.row[field.key], field) }}
                  </template>

                  <template v-else>
                    {{ scope.row[field.key] || '-' }}
                  </template>
                </template>
              </el-table-column>
            </template>


            <el-table-column prop="address" label="类型" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.documentType == 'TEXT'">文档</span>
                <span v-if="scope.row.documentType == 'VEDIO'">视频</span>
                <span v-if="scope.row.documentType == 'MANGA'">漫画</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="上传时间" sortable width="150">
              <template slot-scope="scope">
                {{ $moment(scope.row.createTime).format('YYYY/MM/DD HH:mm') }}
              </template>
            </el-table-column>
            <el-table-column prop="date" label="审核时间" sortable width="150">
              <template slot-scope="scope">
                <template v-if="scope.row.changeTime">
                  {{ $moment(scope.row.changeTime).format('YYYY/MM/DD HH:mm') }}
                </template>
                <template v-else>未审核</template>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="120" fixed="right">
              <template slot-scope="scope">
								<span v-if="scope.row.documentStatus == 'WAIT'">
									<i class="el-icon-info" style="color: #565867;">待审核</i>
								</span>
                <span v-if="scope.row.documentStatus == 'SUCCESS'">
									<i class="el-icon-success" style="color:green;">审核完成</i>
								</span>
                <span v-if="scope.row.documentStatus == 'REVIEW_SUCCESS'">
									<i class="el-icon-success" style="color:green;">复核成功</i>
								</span>
                <span v-if="scope.row.documentStatus == 'ERROR'">
									<el-popover placement="top" title="" width="200" trigger="hover"
                              :content="scope.row.errorMessage" v-if="scope.row.errorMessage">
										<i slot="reference" class="el-icon-error" style="color:brown;">审核未通过</i>
									</el-popover>
									<i slot="reference" class="el-icon-error" style="color:brown;" v-else>审核未通过</i>
								</span>
                <span v-if="scope.row.documentStatus == 'OVER'">
									<i class="el-icon-success" style="color:#999;">已完成</i>
								</span>
              </template>
            </el-table-column>


            <el-table-column v-if="projectInfo.projectSignSwitch=='ON'" label="签署状态" width="120"
                             :key="Math.random().toString(36).substr(2, 9)" fixed="right">
              <template slot-scope="scope">
								<span v-if="scope.row.agreementStatus != 'FINISH'">
									<i class="el-icon-info" style="color: #565867;">待签署</i>
								</span>
                <span v-else>
									<i class="el-icon-success" style="color:green;">已签署</i>
								</span>
              </template>
            </el-table-column>


            <el-table-column label="操作" width="130" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" class="look" @click="pageToDetails(scope.row.filePath)">查看</el-button>

                <el-button v-loading="loadingsign"
                           v-if="scope.row.documentStatus == 'REVIEW_SUCCESS' && projectInfo.projectSignSwitch=='ON' && scope.row.agreementStatus!='FINISH'"
                           type="text" class="look" @click="signContract(scope.row)">劳务签署
                </el-button>
                <el-button type="text" class="updata" @click="updata(scope.row)" v-else
                           :disabled="scope.row.documentStatus == 'SUCCESS'||scope.row.documentStatus == 'OVER' || scope.row.documentStatus == 'REVIEW_SUCCESS'">
                  重新上传
                </el-button>
                <!-- <el-button type="text" class="delete" :disabled="scope.row.documentStatus == 'SUCCESS'"
                  @click="delDocumenteFun(scope.row)">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                       @current-change="handleCurrentChange" :current-page.sync="pageNum"
                       :hide-on-single-page="true"></el-pagination>
      </div>
    </div>

    <el-dialog :visible.sync="loginDialog" v-if="loginDialog" width="600px" :show-close="false"
               :destroy-on-close="true">
      <div class="top" v-if="logType=='登录'">
        <p>登录</p>
        <b>Login</b>
      </div>
      <div class="top" v-if="logType=='注册'">
        <p>注册</p>
        <b>register</b>
      </div>
      <div class="top" v-if="logType=='忘记密码'">
        <p>重置密码</p>
        <b>reset password</b>
      </div>
      <login @loginSuccess="loginSuccessFun($event)" @toRegister="toRegister($event)"></login>
    </el-dialog>

    <el-dialog :visible.sync="registerDialog" v-if="registerDialog" width="900px" :show-close="false">
      <div class="top">
        <p v-if="userInfo.fullName">修改资料</p>
        <p v-else>完善资料</p>
        <b>Improve information</b>
      </div>
      <register @editUserSuccess="registerSuccessFun($event)"></register>
    </el-dialog>

    <el-dialog :visible.sync="contributeDialog" width="900px" :show-close="false">
      <div class="top">
        <p>投稿</p>
        <b>contribute</b>
      </div>
      <!-- 上传文档 -->
      <contribute
          @uploadSuccess="uploadSuccessFun($event)"
          :ai-doc-data="selectedAIDoc"
          :ai-enabled="showAIAssistantIcon"
          @select-from-ai="showAIDocSelect = true"
      ></contribute>
    </el-dialog>

    <!-- 从AI文档库选择弹窗 -->
    <el-dialog
        title="从AI文档库选择"
        :visible.sync="showAIDocSelect"
        width="900px"
        top="8vh"
        class="ai-doc-select-dialog"
    >
      <!-- 搜索区域 -->
      <div class="doc-search-container">
        <div class="search-box">
          <i class="el-icon-search search-icon"></i>
          <el-input
              v-model="searchKey"
              placeholder="搜索文档标题..."
              clearable
              class="search-input"
          />
        </div>
        <div class="header-actions">
          <span class="doc-count">共 <span class="count-num">{{ aiDocList.length }}</span> 个已生成文档</span>
          <el-button type="text" icon="el-icon-refresh" @click="loadAIDocList" class="refresh-btn">刷新</el-button>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="doc-list-container">
        <!-- 空状态 -->
        <div v-if="aiDocList.length === 0" class="empty-state">
          <div class="empty-icon">
            <i class="el-icon-file-text"></i>
          </div>
          <p class="empty-title">暂无已生成的文档</p>
          <p class="empty-desc">请先使用AI助手生成文档</p>
        </div>

        <!-- 文档列表 -->
        <div v-else class="doc-card-list">
          <div
              v-for="(item, index) in filteredDocList"
              :key="index"
              class="doc-card"
              @click="selectAIDoc(item)"
          >
            <div class="card-icon" :class="'type-' + item.genType">
              <span class="icon-text">📄</span>
            </div>
            <div class="card-content">
              <h4 class="card-title">{{ item.title || item.keywords || '未命名文档' }}</h4>
              <div class="card-meta">
                <span class="type-tag">{{ formatGenType(item) }}</span>
                <span class="time-text">{{ formatDateTime(item.createTime) }}</span>
              </div>
            </div>
            <div class="card-action">
              <el-button size="small" type="primary" class="select-btn">选择</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="docView" :visible.sync="docViewShow" v-if="docViewShow">
      <iframe
          :src="previewFileUrl"
          style="width: 100%; height: 100%; border: none;"
          frameborder="0"
          allowfullscreen
      ></iframe>

    </el-dialog>


    <el-dialog class="oldUser" :visible.sync="olduserShow" v-if="olduserShow" width="600px">
      <img src="../../assets/imgs/yanzheng.png" alt="">
      <div class="UserBody">
        <el-alert title="我们检测到系统中多个账户可能属于一个用户，请协助我们核实" type="error" effect="dark"></el-alert>
        <el-row>
          <el-col :span="24"><span class="">账号：</span> <b>{{ oldUser.userName }}</b></el-col>
          <el-col :span="24"><span class="">医院：</span> <b>{{ oldUser.hospital }}</b></el-col>
          <el-col :span="24"><span class="">科室：</span> <b>{{ oldUser.department }}</b></el-col>
          <el-col :span="24"><span class="">用户姓名：</span> <b>{{ oldUser.fullName }}</b></el-col>
          <el-col :span="24"><span class="">身份证号：</span> <b>{{ oldUser.cardId }}</b></el-col>
        </el-row>
      </div>
      <!-- {{oldUser}} -->
      <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="isMyAccount(false)  ">不属于我</el-button>
				<el-button type="success" @click="isMyAccount(true)">此账号属于我</el-button>
			</span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="50%" center>
      <div>尊敬的【{{ userInfo.fullName }}】</div>
      <div v-for="(item,index) in tipList" :key="index">
        <div class="reasonText" v-if="item.type=='user'">您的个人备案信息因【{{
            item.reason
          }}】审核未通过，请及时修改，以免影响您正常的劳务结算流程。
        </div>
        <div class="reasonText" v-if="item.type=='document'">
          您于【{{ $moment(item.submitTime).format('YYYY/MM/DD HH:mm') }}】提交的作品【{{
            item.documentName
          }}】因【{{ item.reason }}】审核未通过，请您修改后重新上传。
        </div>
        <div class="reasonText" v-if="item.type=='sign'">
          您于【{{ $moment(item.submitTime).format('YYYY/MM/DD HH:mm') }}】提交的作品【{{
            item.documentName
          }}】审核通过，请及时完成劳务签署，以免影响您正常的劳务结算流程。
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
				<el-button type="primary" style="width: 100%" @click="confirmCenterDialogVisible">确 定</el-button>
			</span>
    </el-dialog>

    <!-- AI助手弹窗 -->
    <el-dialog
        :visible.sync="showAIAssistant"
        width="50%"
        top="3vh"
        max-height="90vh"
        class="ai-assistant-dialog"
    >
      <AIAssistant @go-publish="handleGoPublish"/>
    </el-dialog>

  </div>
</template>

<script>

import register from '@/components/userCenter/register'
import login from '@/components/userCenter/login'
import contribute from '@/components/userCenter/contribute'
import baseUrl from "@/request/config.js"
import {
  coverUser,
  delDocument,
  documentSign,
  getConfig,
  getProject,
  getTips,
  getUser,
  myDocument,
  myStatistics,
  ProjectPage,
  regist,
} from '@/request/api.js';
import {generateList, getAIConfig} from '@/api/aiassistant';
import AIAssistant from '@/components/AiGenArticleList.vue'

let Base64 = require('js-base64').Base64;
export default {
  name: 'UserCenter',
  components: {
    register,
    login,
    contribute,
    AIAssistant
  },
  data() {
    return {
      loadingsign: false,
      downloading: false,
      centerDialogVisible: false,
      showAIAssistant: false,
      showAIDocSelect: false,
      aiDocList: [],
      selectedAIDoc: null,
      searchKey: '',
      oldUser: '',
      olduserShow: false,
      playOptions: {
        height: "100%",
        width: "100%",
        playbackRates: [1.0, 2.0, 3.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放
        muted: false, // 默认情况下静音播放
        loop: false, // 是否视频一结束就重新开始
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据，auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值，值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小，换句话说，它将按比例缩放以适应其容器
        sources: [{
          // type: "video/mp4", // 类型
          // src: require("./1.mp4"), // url地址，在使用本地的资源时，需要用require()引入，否则控制台会报错
        }],
        poster: "", // 设置封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息
        controlBar: {
          currentTimeDisplay: true,
          progressControl: true, // 是否显示进度条
          playbackRateMenuButton: true, // 是否显示调整播放倍速按钮
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      banner: '',
      userInfo: '',
      tipList: [],
      Statistics: '', // 用户投稿信息
      baseUrl: '',
      docViewShow: false,
      previewFileUrl: '',

      loginDialog: false,
      registerDialog: false,
      contributeDialog: false,
      pageSize: 10,
      total: 0,
      pageNum: 1,
      tableData: [],

      logType: '注册',

      registeData: '',
      projectInfo: {},
      formConfig: [
        // {key: 'documentName', label: '文档名称'},
        // {key: 'documentType', label: '类型', type: 'dict', dictKey: 'doc_type'},
        // {key: 'createTime', label: '上传时间', type: 'datetime'},
        // {key: 'changeTime', label: '审核时间', type: 'datetime'},
        // {key: 'documentStatus', label: '状态', type: 'status'},
      ],
      // 字典映射可选
      dict: {
        doc_type: {
          TEXT: '文档',
          VEDIO: '视频',
          MANGA: '漫画'
        }
      },
      mainColor: '',
    showAIAssistantIcon: false

    }
  },
  created() {
    this.mainColor = localStorage.getItem('mainColor');
    this.baseUrl = baseUrl;
    this.queryProject()

    const headToken = localStorage.getItem('headToken')
    if (headToken) {
      this.getUserFun();
      this.getMyStatistics();
      this.getMyDocument();
      this.getTips();
      // 预加载AI文档列表
      this.loadAIDocList();
    }
    this.getConfigFun();
    this.getProjectFun();

    // 检查是否需要自动打开投稿弹窗
    this.checkOpenContribute();
    // 获取 AI 配置，判断是否显示 AI 助手图标
    this.getAIConfig();
  },
  mounted() {
    this.options();
  },
  computed: {
    filteredDocList() {
      if (!this.searchKey) return this.aiDocList;
      const keyword = this.searchKey.toLowerCase();
      return this.aiDocList.filter(item => {
        const title = (item.title || '').toLowerCase();
        const keywords = (item.keywords || '').toLowerCase();
        return title.includes(keyword) || keywords.includes(keyword);
      });
    }
  },
  watch: {
    "$store.state.logType": {
      handler(val) {
        this.logType = val;
      }
    },
    showAIDocSelect(val) {
      if (val) {
        this.loadAIDocList();
        this.searchKey = '';
      }
    }
  },
  methods: {
    // 首页项目介绍
    getProjectFun() {
      getProject().then(res => {
        if (res.code == 200) {
          this.mainColor = res.data.mainColor;
        }
      })
    },

    // 获取 AI 配置，判断是否显示 AI 助手图标
    getAIConfig() {
      const projectId = localStorage.getItem('projectId') ;
      getAIConfig(projectId).then(res => {
        if (res.code == 200) {
          const data = res.data || {};
          // 如果任意一个功能开启，则显示 AI 助手图标
          this.showAIAssistantIcon = data.science !== false || data.literature !== false || data.caseAnalysis !== false;
        }
      }).catch(err => {
        console.error('获取 AI 配置失败:', err);
        // 默认显示 AI 助手图标
        this.showAIAssistantIcon = true;
      })
    },

    queryProject() {
      ProjectPage().then(res => {
        if (res.code == 200) {
          this.projectInfo = res.data;
          this.formConfig = (JSON.parse(res.data.projectDocumentForm))

        }
      }).catch(err => {
        console.error('查询项目配置失败:', err)
      })
    },

    confirmCenterDialogVisible() {
      this.centerDialogVisible = false;
      const projectId = localStorage.getItem('projectId');
      // 设置过期时间为1小时后
      var expiration = new Date().getTime() + (1 * 60 * 60 * 1000);
      localStorage.setItem('tip' + projectId, JSON.stringify({
        value: 'example',
        expiration: expiration
      }));

    },

    goToAIAssistant() {
      this.showAIAssistant = true;
    },
    getWithExpiration() {
      const projectId = localStorage.getItem('projectId');
      if (!projectId) {
        this.centerDialogVisible = true;
        return;
      }
      const cacheKey = 'tip' + projectId;
      const cachedTipStr = localStorage.getItem(cacheKey);

      if (!cachedTipStr) {
        this.centerDialogVisible = true;
        return;
      }

      try {
        const cachedTip = JSON.parse(cachedTipStr);
        const currentTime = new Date().getTime();

        if (currentTime > cachedTip.expiration) {
          localStorage.removeItem(cacheKey);
          this.centerDialogVisible = true;
        } else {
          this.centerDialogVisible = false;
        }
      } catch (error) {
        console.error("解析缓存数据失败", error);
        localStorage.removeItem(cacheKey); // 清除无效缓存
        this.centerDialogVisible = true;
      }
    },

    // 手动暂停视频的播放
    pause() {
      // 视频播放器的方法调用，要使用this.$refs.videoPlayer.player这个对象去调用
      this.$refs.videoPlayer.player.pause()
    },


    loginDialogFun(item) {
      this.logType = item;
      this.$store.state.logType = item
      this.loginDialog = true;
    },

    // // 下载模版、邀请函
    // download(link) {
    //   window.open(`${this.baseUrl}${link}`)
    //
    //   // <dl @click="download(`/article/template/downloadTemplate`)">
    //   // <dl @click="download(`/article/template/downloadInvitation`)">
    // },

    // 下载模版、邀请函
    // download(link) {
    //   fetch(`${this.baseUrl}${link}`, { // 替换为实际接口路径
    //     method: 'GET',
    //     headers: {
    //       // 若需要认证，需携带 Token
    //       'Project-Id': localStorage.getItem('projectId')
    //     }
    //   })
    //       .then(response => {
    //         if (!response.ok) throw new Error('下载失败');
    //         return response.blob(); // 将响应转为 Blob 对象
    //       })
    //       .then(blob => {
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = 'template.zip'; // 与后端 Content-Disposition 中的文件名一致
    //         a.style.display = 'none';
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);
    //         window.URL.revokeObjectURL(url); // 释放内存
    //       })
    //       .catch(error => {
    //         console.error('下载错误:', error);
    //         alert('文件下载失败，请重试');
    //       });
    // },
    download(link) {
      if (this.downloading) return;
      this.downloading = true;

      let filename = 'template.zip';
      fetch(`${this.baseUrl}${link}`, {
        method: 'GET',
        headers: {
          'Project-Id': localStorage.getItem('projectId')
        }
      }).then(response => {
        if (!response.ok) throw new Error('下载失败');

        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
          const filenameRegex = /filename\*?=["']?(?:UTF-\d['"]*)?([^;\n"]*)["']?;?/i;
          const matches = filenameRegex.exec(contentDisposition);
          if (matches && matches[1]) {
            filename = decodeURIComponent(matches[1]);
          }
        }

        return response.blob();
      }).then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
          .catch(error => {
            console.error('下载错误:', error);
            this.$notify({
              title: '下载失败',
              message: '文件下载失败，请重试',
              type: 'error',
              position: 'bottom-right'
            });
          })
          .finally(() => {
            this.downloading = false;
          });

      this.$notify({
        title: '提示',
        message: '正在下载，请稍等',
        type: 'success',
        position: 'bottom-right'
      });

    },
    // 快捷操作
    options() {
      let query = this.$route.query.opt;
      if (query == 'register') {
        this.loginDialogFun('注册');
      } else if (query == 'contribute') {
        setTimeout(() => {
          this.contributeDialogCk();
        }, 300)
      }
    },

    // 暂停投稿   2024“星火计划”肿瘤科普作品征集项目

    suspendSubmission() {
      // alert('2024“星火计划”肿瘤科普作品征集项目已结束，感谢您的关注。');
      this.$alert('2024“星火计划”肿瘤科普作品征集项目维护中，<br>投稿渠道已暂时关闭，感谢您的关注。', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        closeOnPressEscape: true,
        closeOnClickModal: true,
        center: true
      });
    },

    // 完善信息
    registerDialogCk() {
      // this.suspendSubmission();
      // return false;

      if (this.userInfo) {
        this.registerDialog = true;
      } else {
        this.$confirm('您还未登录，是否现在登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.loginDialog = true;
          this.$store.state.logType = '登录';
          this.logType = '登录'
        })
      }
    },

    // 立即投稿
    contributeDialogCk() {
      //投稿的时候清除重新上传时候的文档id 用于文件上传数量校验给后端
      this.$store.state.documentId = ''

      if (!this.userInfo) {
        this.$confirm('您还未登录，是否现在登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.loginDialog = true;
          this.$store.state.logType = '登录';
          this.logType = '登录'
        })
      } else if (this.userInfo.infoStatus === 'INCOMPLETE') {
        this.$confirm('您需要填写基础个人信息并完善备案信息后才能参与投稿，是否现在去完善信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.registerDialog = true;
        })
      } else if (this.userInfo.infoStatus === 'REJECTED') {
        this.$confirm(`您的四证信息被驳回，驳回理由：【${this.userInfo.certificatesMessage}】，请重新上传并确认。`, '提示', {
          confirmButtonText: '重新上传',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.registerDialog = true;
        })
      } else if (this.userInfo.infoStatus === 'REVIEWING') {
        this.$confirm('您的个人信息正在审核中，请稍后再试。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        })
      } else if (this.userInfo.infoStatus === 'SUCCESS') {
        this.contributeDialog = true;
      } else {
        // 兜底：如果 infoStatus 异常，也提示用户
        this.$confirm('用户信息状态异常，请重新登录或完善信息。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.registerDialog = true;
        })
      }
    },

    // 跳转到AI生成页面
    goToAIGenerate() {
      this.contributeDialog = false;
      this.$router.push({name: 'generate'});
    },

    // 检查是否需要自动打开投稿弹窗
    checkOpenContribute() {
      const openContribute = localStorage.getItem('openContribute');
      if (openContribute === 'true') {
        localStorage.removeItem('openContribute');
        setTimeout(() => {
          this.contributeDialogCk();
        }, 300);
      }
    },

    // 加载AI文档列表（只显示生成成功的文档）
    loadAIDocList() {
      generateList().then(res => {
        if (res.code === 200) {
          // 只保留生成成功的文档
          this.aiDocList = (res.data || []).filter(item => {
            return item.genStatus === 'succeeded' || item.genStatus === '2'
          })
        }
      })
    },


    // 选择AI文档
    selectAIDoc(row) {
      this.selectedAIDoc = {...row};
      // 使用 genId 而不是直接使用文件路径
      localStorage.setItem('genId', row.genId);
      this.showAIDocSelect = false;
    },

    // 格式化类型显示
    formatGenType(row) {
      const type = row.genType || row;
      return type === '01' ? '科普征文' : (type === '02' ? '文献解读' : '案例解读');
    },

    // 格式化日期时间
    formatDateTime(dateStr) {
      if (!dateStr) return '未知时间';
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return '未知时间';
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }).replace(/\//g, '-');
    },

    // 处理AI助手的去发布
    handleGoPublish(data) {
      if (!data || !data.genId) {
        this.$message.error('文档数据异常');
        return;
      }
      // 存入本地存储（投稿页面读取）
      localStorage.setItem('genId', data.genId);
      this.selectedAIDoc = {...data};
      // 关闭AI弹窗
      this.showAIAssistant = false;
      // 延后打开投稿
      this.$nextTick(() => {
        this.contributeDialog = true;
      })
    },

    // 获取我的投稿记录
    getMyDocument() {
      let data = {
        current: this.pageNum,
        size: this.pageSize,
      };
      myDocument(data).then(res => {
        if (res.code == 200) {
          this.total = res.data.total;
          this.tableData = res.data.records.map(record => {
            try {
              const formData = JSON.parse(record.documentFormData);
              return {
                ...record,
                ...formData
              };
            } catch (e) {
              console.error('JSON 解析失败:', record.documentFormData);
              return record;
            }
          });
        }
      }).catch(err => {
        console.error('获取投稿记录失败:', err)
      })
    },

    // 获取用户投稿信息
    getMyStatistics() {
      myStatistics().then(res => {
        if (res.code == 200) {
          this.Statistics = res.data
        }
      }).catch(err => {
        console.error('获取投稿统计失败:', err)
      })
    },

    getTips() {
      getTips().then(res => {
        if (res.code == 200) {
          this.tipList = res.data;
          if (this.tipList.length != 0) {
            this.getWithExpiration()

          }
        }
      })
    },


    // 获取用户信息
    getUserFun() {
      getUser().then(res => {
        if (res.code == 200) {
          this.userInfo = res.data;
          this.$forceUpdate()
        } else {
        }
      })
    },
    // getUserFun2() {
    // 	getUser().then(res => {
    // 		if (res.code == 200) {
    // 			this.userInfo = res.data;
    // 			if (!this.userInfo.cardId || !this.userInfo.fullName) {
    // 				this.$confirm('您需要完善个人资料后才可以进行投稿，现在否去完善资料？', '提示', {
    // 					confirmButtonText: '去完善资料',
    // 					type: 'info'
    // 				}).then(() => {
    // 					this.registerDialog = true;
    // 				}).catch(err => {
    // 					console.log(err)
    // 				})
    // 			}
    // 		}
    // 	})
    // },

    isMyAccount(flag) {
      let data = this.registeData;
      const type = flag ? '账号合并' : '注册';
      if (flag) {
        coverUser(data).then(res => {
          if (res.code == 200) {
            this.olduserShow = false;
            localStorage.setItem('headToken', res.data);
            this.$notify({
              title: `${type}成功`,
              message: `${type}成功`,
              type: 'success',
              position: 'bottom-right'
            });
            location.reload();
          } else {
            this.$notify({
              title: `${type}失败`,
              message: `${res.msg}`,
              type: 'error',
              position: 'bottom-right'
            });
          }
        }).catch(err => {
          console.error(`${type}异常:`, err);
          this.$notify({
            title: `${type}失败`,
            message: '网络异常，请稍后重试',
            type: 'error',
            position: 'bottom-right'
          });
        })
      } else {
        data.userName = data.userName + "B";
        regist(data).then(res => {
          if (res.code == 200) {
            this.olduserShow = false;
            localStorage.setItem('headToken', res.data);
            this.$notify({
              title: `${type}成功`,
              message: `${type}成功`,
              type: 'success',
              position: 'bottom-right'
            });
            location.reload();
          } else {
            this.$notify({
              title: `${type}失败`,
              message: `${res.msg}`,
              type: 'error',
              position: 'bottom-right'
            });
          }
        }).catch(err => {
          console.error(`${type}异常:`, err);
          this.$notify({
            title: `${type}失败`,
            message: '网络异常，请稍后重试',
            type: 'error',
            position: 'bottom-right'
          });
        })
      }
    },

    // 登录成功后
    loginSuccessFun(e) {
      if (e.type) {
        this.loginDialog = false;
        this.getUserFun();
        this.getMyStatistics();
        this.getMyDocument();
        this.getTips();
      }
      if (e.oldUser) {
        this.olduserShow = true;
        this.oldUser = e.oldUser
        this.registeData = e.registeData
      }
    },

    // 去注册
    toRegister(e) {
      if (e.type) {
        this.loginDialog = false;
        this.registerDialog = true;
      }
    },

    // 切换项目
    switchItems() {
      this.$confirm('是否确认切换项目?', '确认', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        // localStorage.clear();
        // this.$router.go(0);
        // window.location.reload();
        this.$router.push({
          name: 'switchItems'
        })

      })
    },

    // 退出登录
    logOut() {
      this.$confirm('是否确认退出登录?', '确认', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.getUserFun();
        this.getMyStatistics();
        this.getMyDocument();
        //项目id与项目名称不要清除
        const projectId = localStorage.getItem('projectId');
        const projectName = localStorage.getItem('projectName');
        localStorage.clear();
        localStorage.setItem('projectName', projectName);
        localStorage.setItem('projectId', projectId);

        this.tableData = [];
        this.userInfo = '';
        this.$notify({
          title: '退出成功',
          message: `退出成功`,
          type: 'success',
          position: 'bottom-right'
        });
        this.$router.go(0);
        // window.location.reload();
      })
    },

    // 投稿成功后子组件传值
    uploadSuccessFun(e) {
      if (e.type) {
        this.contributeDialog = false;
        this.getMyStatistics();
        this.getMyDocument();
      }
    },

    // 注册成功后子组件传值
    registerSuccessFun(e) {
      if (e.type) {
        this.registerDialog = false;
      }
      this.getUserFun();
    },


    // pageToDetails(row) {

    //   this.docViewShow = true;
    //   if (row.documentType == "VEDIO") {
    //     this.playOptions.sources = [{
    //       src: row.filePath
    //     }]
    //     this.playOptions.poster = row.imagePath
    //   }
    // },


    // 统一文件预览
    pageToDetails(url, title) {
      if (!url) return
      let isImage = false
      const imgReg = /\.(jpg|jpeg|png|gif|bmp|webp)$/i
      // 压缩包正则：zip/rar/7z/tar/gz
      const zipReg = /\.(zip|rar|7z|tar|gz)$/i


      try {
        // 截断OSS签名参数，取纯文件路径
        const pureUrl = url.split('?')[0] || ''
        // 判断是否为图片
        isImage = imgReg.test(pureUrl)
        // 判断是否为压缩包
        if (zipReg.test(pureUrl)) {
          // 压缩包直接新标签页打开
          let zipBase64 = Base64.encode(url).replace(/[\r\n]/g, '')
          let zipPreviewUrl = 'https://vanmu.life-oasis.com/kkFileView/onlinePreview?url='
              + encodeURIComponent(zipBase64)
          window.open(zipPreviewUrl)
          return
        }
      } catch (e) {
        // 截取/解析异常，标记为非图片，走默认预览
        console.error('文件路径解析异常', e)
        isImage = false
      }

      // 图片 → 图片预览器
      if (isImage) {
        const imgList = [url]
        this.$viewerApi({
          images: imgList,
          options: {
            initialViewIndex: 0
          }
        })
        return
      }

      // 非图片、非压缩包 → kkFileView 弹窗预览
      let previewUrl = ''
      const pureUrl = url.split('?')[0] || ''
      // 1. base64编码
      let base64Str = Base64.encode(url)
      // 2. 去除base64自动生成的 \r \n 换行符（关键修复）
      base64Str = base64Str.replace(/[\r\n]/g, '')
      // 3. 再进行url编码
      const encodeUrl = encodeURIComponent(base64Str)

      if (/\.(pdf)$/i.test(pureUrl)) {
        previewUrl = 'https://vanmu.life-oasis.com/kkFileView/onlinePreview?url='
            + encodeUrl + '&officePreviewType=pdf'
      } else {
        previewUrl = 'https://vanmu.life-oasis.com/kkFileView/onlinePreview?url='
            + encodeUrl
      }

      this.previewFileUrl = previewUrl
      // this.previewFileName = title
      this.docViewShow = true;
    },


    //去签署合同
    signContract(row) {
      this.loadingsign = true;
      documentSign({
        documentId: row.id
      }).then(res => {
        if (res.code == 200) {
          window.open(res.data.actorSignTaskEmbedUrl)
          this.loadingsign = false;
        } else {
          this.$notify({
            title: '签署失败',
            message: `${res.msg}`,
            type: 'error',
            position: 'bottom-right'
          });
          this.loadingsign = false;
        }
      }).catch(err => {
        this.loadingsign = false;
        console.error('签署异常:', err);
        this.$notify({
          title: '签署失败',
          message: '网络异常，请稍后重试',
          type: 'error',
          position: 'bottom-right'
        });
      })

    },

    // 上传与重新上传
    updata(row) {
      if (row && row.id) {
        this.$store.state.documentId = row.id;
        setTimeout(() => {
          this.contributeDialog = true;
        }, 100)
      }
    },

    // 删除文档
    delDocumenteFun(row) {
      this.$confirm('您确定要删除这条投稿么？', '确认', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        let data = {
          id: row.id
        }
        delDocument(data).then(res => {
          if (res.code == 200) {
            this.$notify({
              title: '删除成功',
              message: `${res.msg}`,
              type: 'success',
              position: 'bottom-right'
            });
            this.getMyStatistics();
            this.getMyDocument();
          } else {
            this.$notify({
              title: '删除失败',
              message: `${res.msg}`,
              type: 'error',
              position: 'bottom-right'
            });
          }

        }).catch(err => {
          console.error('删除文档失败:', err)
        })
      })

    },

    TabsChange(val) {
    },

    handleCurrentChange(val) {
      this.pageNum = val
      this.getMyDocument();
    },
    // 首页获取logo banner 流程图
    getConfigFun() {
      getConfig().then(res => {
        if (res.code == 200) {
          this.banner = res.data.bannerPath;
        }
      })
    },

    formatDictValue(value, field) {
      return this.dict[field.dictKey]?.[value] || value;
    },
    formatStatus(status) {
      switch (status) {
        case 'WAIT':
          return '待审核';
        case 'SUCCESS':
          return '审核完成';
        case 'ERROR':
          return '审核未通过';
        case 'OVER':
          return '已完成';
        default:
          return '';
      }
    },

    // 格式化多选框值
    formatCheckboxValue(value, field) {
      if (!value || !Array.isArray(value)) return '-'

      return value.map(v => {
        const option = field.options.find(opt => (opt.value !== undefined ? opt.value : opt.label) === v)
        return option ? option.label : v
      }).join(', ')
    },

    // 格式化单选框值
    formatRadioValue(value, field) {
      if (!value) return '-'
      const option = field.options.find(opt => (opt.value !== undefined ? opt.value : opt.label) === value)
      return option ? option.label : value
    }
  }
}
</script>

<style lang="scss" scoped>
$main-color: v-bind(mainColor); // 注意这里的写法在某些构建工具中可能不支持，需要使用其他方法

#UserCenter {
  .reasonText {
    margin: 7px 0;
  }


  ::v-deep .el-dialog {
    border-radius: 10px;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 50px 20px;
    }

    .top {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;

      p {
        font-size: 36px;
        color: rgba(31, 32, 34, 1);
      }

      b {
        font-size: 18px;
        color: $main-color;
      }
    }

    // 投稿方式选项卡
    .submit-tabs {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
      border-bottom: 1px solid #eee;

      .tab-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 30px;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        transition: all 0.3s;
        font-size: 16px;
        color: #666;

        &:hover {
          color: $main-color;
        }

        &.active {
          color: $main-color;
          border-bottom-color: $main-color;
          font-weight: 600;
        }

        i {
          font-size: 18px;
        }
      }
    }

    // AI入口样式
    .ai-entrance {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 60px 40px;
      text-align: center;

      .ai-description {
        margin-bottom: 30px;

        h3 {
          font-size: 24px;
          color: #333;
          margin-bottom: 12px;
        }

        p {
          font-size: 14px;
          color: #666;
          margin-bottom: 20px;
        }

        ul {
          text-align: left;
          display: inline-block;

          li {
            font-size: 14px;
            color: #666;
            margin-bottom: 8px;
            list-style: none;
          }
        }
      }

      .el-button {
        width: 200px;
        height: 48px;
        font-size: 16px;
      }
    }
  }


  ::v-deep .oldUser {
    .el-dialog {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      max-height: 90vh;
      overflow: hidden;
      margin: 0 !important;
    }

    .el-dialog__body {
      overflow: hidden;
      padding: 0;

      img {
        display: block;
        width: 100%;
      }
    }

    .UserBody {
      padding: 20px;

      .el-row {
        margin-top: 20px;
      }

      .el-col {
        margin-bottom: 20px;
        display: flex;
        font-size: 15px;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }

        span {
          width: 100px;
          text-align: right;
          color: #112950;
          font-size: 14px;
        }

        b {
          padding: 8px 20px;
          border: 1px solid #ccc;
          flex: 1;
          border-radius: 8px;
          font-weight: normal;
          color: #000;
          height: 42px;
        }
      }
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .el-button {
        width: 45%;
      }
    }

  }

  ::v-deep .docView {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .el-dialog {
      margin: 0 !important;
      width: 1200px;
      height: 90vh;

      .el-dialog__body {
        height: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        .video-player {
          flex: 1;
        }

        .vjs-big-play-button {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .banner {
    height: 630px;
    position: relative;
    width: 1200px;
    border-radius: 30px;
    overflow: hidden;
    margin: 20px auto 40px;

    .frame {
      display: none;
      position: absolute;
      height: 140%;
      right: -40px;
      top: 50%;
      transform: translateY(-50%);
    }

    .webHander {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      z-index: 1;
    }

    .background {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    .mask {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 0;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(252, 253, 255, 1) 100%)
    }

    .main {
      position: absolute;
      width: 1000px;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      .ban {
        height: 100px;
        margin-left: -30px;
        margin-bottom: 100px;
      }

      .cont {
        display: flex;
        flex-direction: column;

        p {
          font-size: 70px;
          font-weight: 600;
          line-height: 1.5;
          color: aliceblue;
          color: #0082CE;
        }

        b {
          font-size: 16px;
          font-weight: normal;
          margin-top: 12px;
          color: #666;
          opacity: .8;
          line-height: 1.5;

          img {
            height: 36px;
          }
        }
      }
    }
  }

  .user {
    width: 1200px;
    margin: 25px auto 0;
    border-bottom: 2px solid rgba(229, 229, 229, .6);
    border-top: 2px solid rgba(229, 229, 229, .6);
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 20px 0;

    .el-divider {
      height: 100px;
      width: 2px;
    }

    .el-avatar {
      width: 106px;
      height: 106px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 50px;
    }

    .el-button {
      width: 150px;
      height: 50px;
      border-radius: 8px;
      background: rgba(203, 50, 44, 0);
      border: 1px dashed $main-color;
      transition: all .3s;
      font-size: 16px;
      padding: 0;
      margin: 5px 0;

      &:hover {
        color: $main-color;
        border: 1px solid $main-color;
      }
    }

    div {
      display: flex;
      flex-direction: column;

      p {
        font-size: 60px;
        color: $main-color;
        text-align: center;
      }

      b {
        font-size: 28px;
        color: #333;
        font-weight: normal;
        text-align: center;
      }
    }
  }

  .part3 {
    padding: 100px 0 0;

    .tit {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 60px;

      p {
        font-size: 36px;
        text-align: center;
        color: rgba(31, 32, 34, 1);
      }

      b {
        font-size: 18px;
        text-align: center;
        color: $main-color;
      }
    }

    .cont {
      width: 1200px;
      margin: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-around;

      dl {
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;

        * {
          cursor: pointer;
        }

        dt {
          font-size: 40px;
          width: 160px;
          height: 160px;
          border-radius: 40px;
          border: 2px solid #f4f4f4;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.08);

          img {
            width: 100px;
            height: 100px;
          }

        }

        dd {
          font-size: 28px;
          color: rgba(0, 0, 0, 1);
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }

  .part2 {
    padding: 100px 0 0;

    .tit {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 60px;

      p {
        font-size: 36px;
        text-align: center;
        color: rgba(31, 32, 34, 1);
      }

      b {
        font-size: 18px;
        text-align: center;
        color: $main-color;
      }
    }

    .cont {
      width: 1200px;
      margin: auto;
      padding: 40px 35px;
      box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.05);

      ::v-deep .el-tabs {

        .el-tabs__item {
          font-size: 20px;

          &:hover {
            color: rgba(203, 50, 44, .8);
          }
        }

        .el-tabs__item.is-active {
          color: $main-color;
        }

        .el-tabs__active-bar {
          background-color: $main-color;
        }
      }

      .el-pagination {
        text-align: center;
        margin-top: 20px;
      }

      .document,
      .video,
      .comic {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;

        dl {
          width: 31%;
          margin-bottom: 30px;

          dt {
            .el-image {
              width: 100%;
              height: 180px;
              border-radius: 4px;
            }
          }

          dd {
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            margin-top: 18px;
          }
        }
      }
    }
  }
}

/* AI助手弹窗样式 */
.ai-assistant-dialog {
  ::v-deep .el-dialog {
    border-radius: 10px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }

  ::v-deep .el-dialog__body {
    padding: 0;
    max-height: 90vh;
    overflow-y: auto;
  }
}

/* AI文档选择弹窗样式 */
.ai-doc-select-dialog {
  ::v-deep .el-dialog__header {
    background: #0F766E;
    padding: 16px 24px;
    border-radius: 10px 10px 0 0;

    .el-dialog__title {
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.3px;
    }

    .el-dialog__close {
      color: rgba(255, 255, 255, 0.7);

      &:hover {
        color: #fff;
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 20px;
    background: #F8F8F7;
    max-height: 60vh;
    overflow-y: auto;
  }
}

.doc-search-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 16px;

  .search-box {
    flex: 1;
    position: relative;

    .search-icon {
      position: absolute;
      left: 14px;
      top: 50%;
      transform: translateY(-50%);
      color: #A8A29E;
      font-size: 14px;
    }

    .search-input {
      width: 100%;
      padding-left: 40px;

      ::v-deep .el-input__inner {
        border-color: #E8E6E3;
        border-radius: 6px;

        &:focus {
          border-color: #0F766E;
        }
      }
    }
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 12px;

    .doc-count {
      font-size: 13px;
      color: #78716C;

      .count-num {
        color: #0F766E;
        font-weight: 600;
      }
    }

    .refresh-btn {
      color: #0F766E;
    }
  }
}

.doc-list-container {
  min-height: 300px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;

  .empty-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #F0FDFA;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;

    i {
      font-size: 28px;
      color: #0F766E;
    }
  }

  .empty-title {
    font-size: 15px;
    font-weight: 600;
    color: #1A1A1A;
    margin: 0 0 6px 0;
  }

  .empty-desc {
    font-size: 13px;
    color: #A8A29E;
    margin: 0;
  }
}

.doc-card-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.doc-card {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #E8E6E3;
  border-left: 3px solid transparent;

  &:hover {
    border-left-color: #0F766E;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .card-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    flex-shrink: 0;

    .icon-text {
      font-size: 18px;
    }

    &.type-01 {
      background: #F0FDFA;
      color: #0F766E;
    }

    &.type-02 {
      background: #EFF6FF;
      color: #1E40AF;
    }

    &.type-03 {
      background: #F5F3FF;
      color: #7C3AED;
    }
  }

  .card-content {
    flex: 1;
    overflow: hidden;

    .card-title {
      font-size: 14px;
      font-weight: 600;
      color: #1A1A1A;
      margin: 0 0 4px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .card-meta {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 12px;

      .type-tag {
        padding: 1px 8px;
        border-radius: 4px;
        background: #F5F5F4;
        color: #57534E;
        font-size: 11px;
      }

      .time-text {
        color: #A8A29E;
      }
    }
  }

  .card-action {
    margin-left: 12px;
    flex-shrink: 0;

    .select-btn {
      background: #0F766E;
      border: none;
      border-radius: 6px;
      padding: 5px 14px;
      font-size: 12px;
      font-weight: 500;

      &:hover {
        background: #0D6B63;
      }
    }
  }
}
</style>
